export function Modal({ title, children, onClose, headerStyle, fixedHeader, footer }) {
  return (
    <div className="modal-backdrop">
      <div className="modal">
        <header style={headerStyle}>
          <h2>{title}</h2>
          <button onClick={onClose} style={headerStyle ? { background: "rgba(255,255,255,0.15)", borderColor: "rgba(255,255,255,0.3)", color: "#fff" } : undefined}>Close</button>
        </header>
        {fixedHeader}
        <div className="modal-body">{children}</div>
        {footer}
      </div>
    </div>
  );
}
